export enum IrbSettingsEvents {
    SHOW = "IRBSETTINGEVENTS.SHOW",
    IS_MODIFIED = "IRBSETTINGEVENTS.IS_MODIFIED",
    IS_NOT_MODIFIED = "IRBSETTINGEVENTS.IS_NOT_MODIFIED",
    UPDATE = "IRBSETTINGEVENTS.UPDATE",
    SAVE = "IRBSETTINGEVENTS.SAVE",
    SAVE_WITHOUT_MORNING_STAR = "IRBSETTINGEVENTS.SAVE_WITHOUT_MORNING_STAR",
    SAVE_SUCCESS = "IRBSETTINGEVENTS.SAVE_SUCCESS",
    SAVE_ERROR = "IRBSETTINGEVENTS.SAVE_ERROR",
    UNSAVED_CHANGES = "IRBSETTINGEVENTS.UNSAVED_CHANGES",
    CLOSE_WITHOUT_SAVE = "IRBSETTINGEVENTS.CLOSE_WITHOUT_SAVE",
    SAVE_START = "IRBSETTINGEVENTS.SAVE_START",
    REVERT_CHANGES = "IRBSETTINGEVENTS.REVERT_CHANGES",
    CHECK_RESTRICTION = "IRBSETTINGEVENTS.CHECK_RESTRICTION",
    CHECK_RESTRICTION_DELETE_CATEGORY = "IRBSETTINGEVENTS.CHECK_RESTRICTION_DELETE_CATEGORY",
    DELETE_ASSET_CATEGORY = "IRBSETTINGEVENTS.DELETE_ASSET_CATEGORY",
    DELETE_ASSET_CATEGORY_SINGLE = "IRBSETTINGEVENTS.DELETE_ASSET_CATEGORY_SINGLE",
    DELETE_ASSET_REMOVE_ALL = "IRBSETTINGEVENTS.DELETE_ASSET_REMOVE_ALL",
    DELETE_ASSET_REMOVE = "IRBSETTINGEVENTS.DELETE_ASSET_REMOVE",
    SECURITY_EXISTING = "IRBSETTINGEVENTS.SECURITY_EXISTING",
    SHOW_DELETE_ASSET_CATEGORY = "IRBSETTINGEVENTS.SHOW_DELETE_ASSET_CATEGORY",
    SHOW_MODEL_REBALANCE_WARNING = "IRBSETTINGEVENTS.SHOW_MODEL_REBALANCE_WARNING",
    PROCEED_SAVE = "IRBSETTINGEVENTS.PROCEED_SAVE",
    ASSET_CATEGORY_UPDATED = "IRBSETTINGEVENTS.ASSET_CATEGORY_UPDATED",
    SHOW_ANNOUNCEMENT_EDIT = "IRBSETTINGEVENTS.SHOW_ANNOUNCEMENT_EDIT",
    SHOW_PORTFOLIOS_BY_CATEGORY="IRBSETTINGEVENTS.SHOW_PORTFOLIOS_BY_CATEGORY",
    PORTFOLIO_CATEGORY_UPDATED="IRBSETTINGEVENTS.PORTFOLIO_CATEGORY_UPDATED",
    SHOW_SECURITIES_BY_CATEGORY="IRBSETTINGEVENTS.SHOW_SECURITIES_BY_CATEGORY",
    SHOW_IMPORT_SEC_JOB_STATUS="IRBSETTINGEVENTS.SHOW_IMPORT_SEC_JOB_STATUS",
    SHOW_TAB = "IRBSETTINGEVENTS.SHOW_TAB",
    NAVIGATE = "IRBSETTINGEVENTS.NAVIGATE",
    EXPAND_AUTO_CASH = "IRBSETTINGEVENTS.EXPAND_AUTO_CASH",
    GLOBAL_SETTINGS_REFRESH = "IRBSETTINGEVENTS.GLOBAL_SETTINGS_REFRESH",
    SHOW_WASH_SALE_INFO = "IRBSETTINGEVENTS.SHOW_WASH_SALE_INFO",
    EXPAND_CUSTOM_LABELS = "IRBSETTINGEVENTS.EXPAND_CUSTOM_LABELS"
}
